import React from 'react';
import { FaLock } from 'react-icons/fa';

const SecurityNotice: React.FC = () => {
    return (
        <section className="w-full px-4 sm:px-6 py-20 md:py-24 bg-gray-50/60">
            <div className="max-w-7xl mx-auto rounded-3xl">
                <div
                    className="relative overflow-hidden p-8 md:p-16 rounded-3xl shadow-sm border border-gray-200 bg-white"
                >
                    {/* Background shard decoration */}
                    <div className="absolute top-0 right-0 w-40 h-40 bg-secondary opacity-10 rotate-45 -mr-20 -mt-20 pointer-events-none rounded-3xl" />

                    <div className="relative z-10 flex flex-col lg:flex-row gap-12 md:gap-20 items-start rounded-3xl">
                        {/* Left Side: Header & Content */}
                        <div className="flex-1 space-y-10 w-full">
                            <div className="flex flex-col sm:flex-row sm:items-center gap-6 md:gap-8">
                                <div className="inline-flex p-5 bg-text-primary border-b-4 border-secondary shadow-xl w-fit">
                                    <FaLock className="text-secondary text-2xl md:text-3xl" />
                                </div>
                                <div>
                                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter uppercase leading-none text-text-primary">
                                        Security <span className="text-secondary">Protocol.</span>
                                    </h2>
                                    <p className="text-[10px] md:text-[12px] font-black text-text-primary/40 uppercase tracking-[0.4em] mt-3">
                                        Fraud Awareness • Surveillance
                                    </p>
                                </div>
                            </div>

                            <p className="text-lg sm:text-xl md:text-2xl font-bold leading-relaxed text-text-secondary max-w-3xl border-l-[6px] border-text-primary/10 pl-8">
                                <span className="text-text-primary">Advisory:</span> Fraudsters are impersonating employees via unauthorized channels.
                                Exercise extreme caution.
                            </p>

                            <ul className="space-y-4">
                                {[
                                    "Do not click unauthorized links or reply to suspicious telemetry",
                                    "Verify institutional email IDs and domains before engagement",
                                    "Escalate any suspicious calls to our official support terminal"
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-4 group">
                                        <div className="w-2 h-2 bg-secondary mt-2.5 shrink-0" />
                                        <span className="text-sm sm:text-base font-black uppercase tracking-widest text-text-primary/70 group-hover:text-text-primary transition-colors">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Right Side: Safe Payment Box */}
                        <div className="w-full lg:w-[420px] shrink-0">
                            <div
                                className="p-10 bg-text-primary text-white border-r-8 border-secondary shadow-2xl relative overflow-hidden h-full"
                            >
                                <div className="flex items-center gap-4 mb-8">
                                    <div className="w-1.5 h-6 bg-secondary" />
                                    <h3 className="text-[11px] font-black text-secondary uppercase tracking-[0.4em]">
                                        Terminal: Secure
                                    </h3>
                                </div>
                                <p className="text-xl md:text-2xl font-black mb-10 leading-tight tracking-tight uppercase">
                                    Execute payments only via official protocols.
                                </p>
                                <div className="pt-8 border-t border-white/10">
                                    <p className="text-sm md:text-base font-bold leading-relaxed opacity-60 italic" lang="hi">
                                        भुगतान केवल आधिकारिक वेबसाइट से करें। किसी अज्ञात लिंक पर भरोसा न करें।
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default SecurityNotice;

